import Controller from '@ember/controller'
import { action } from '@ember/object'
import { tracked } from '@glimmer/tracking'
import { serialize as serializeSort, deserialize as deserializeSort } from '@blakeelearning/data-tables/utils/sorting'
import type { SortingConfig } from '@blakeelearning/data-tables/utils/sorting'
import type { PaginationConfig } from '@blakeelearning/data-tables/utils/paging'
import {
  serialize as serializeSelected,
  deserialize as deserializeSelected,
} from '@blakeelearning/data-tables/utils/selecting'
import { GradeOptionTypes } from 'teacher-ui-client/components/base/select/grade-position/options'
import { SchoolClassOptionTypes } from 'teacher-ui-client/components/base/select/school-class/options'
import type { RowId } from 'teacher-ui-client/components/stable-table/basic-table/cell'

export default class BookLibrarySharesNewController extends Controller {
  queryParams = ['sort', 'pageNumber', 'perPage', 'selected', 'search', 'grade', 'schoolClass']

  @tracked
  sort = 'firstName'

  @tracked
  pageNumber = 1

  @tracked
  perPage = 10

  @tracked
  selected = ''

  @tracked
  search = ''

  @tracked
  grade: number | GradeOptionTypes.All = GradeOptionTypes.All

  @tracked
  schoolClass: string | SchoolClassOptionTypes.All = SchoolClassOptionTypes.All

  get sortingConfig() {
    return deserializeSort(this.sort)
  }

  set sortingConfig(newSortConfig) {
    this.sort = serializeSort(newSortConfig)
  }

  get paginationConfig(): PaginationConfig {
    return { pageNumber: Number(this.pageNumber), perPage: Number(this.perPage) }
  }

  get selectedStudentIds() {
    return deserializeSelected(this.selected, String)
  }

  set selectedStudentIds(newSelectedIds) {
    this.selected = serializeSelected(newSelectedIds)
  }

  @action
  updateSorts(sortingConfig: SortingConfig) {
    this.sortingConfig = sortingConfig
  }

  @action
  updateSelected(studentIds: RowId[]) {
    this.selectedStudentIds = [...studentIds.filter((studentId): studentId is string => typeof studentId === 'string')]
  }

  @action
  updateSearch(value: string) {
    this.search = value
  }

  @action
  updateGrade(value: number | GradeOptionTypes.All) {
    this.grade = value
  }

  @action
  updateSchoolClass(value: string | SchoolClassOptionTypes.All) {
    this.schoolClass = value
  }
}

declare module '@ember/controller' {
  interface Registry {
    'subscription-type/book-library/shares/new': BookLibrarySharesNewController
  }
}
